import { render } from "./GeneralCard.vue?vue&type=template&id=7ba5c4f3&ts=true"
import script from "./GeneralCard.vue?vue&type=script&lang=ts"
export * from "./GeneralCard.vue?vue&type=script&lang=ts"

import "./GeneralCard.vue?vue&type=style&index=0&id=7ba5c4f3&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__